import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

const StarRating = ({ rating }) => {
  return (
    <div className="flex mx-4">
        {Array.from({ length: 5 }, (_, index) => {
          const fillPercentage = Math.min(100, Math.max(0, (rating - index) * 100));

          return (
            <div key={index} className="relative w-6 h-6 bg-gray-300">
              {/* Empty Star (Gray) */}
              <FontAwesomeIcon icon={faStar} className="text-gray-300 absolute inset-0" />
              
              {/* Filled Star (Gold) */}
              <div
                className="absolute inset-0"
                style={{
                  width: `${fillPercentage}%`,
                  overflow: "hidden",
                  maskImage: "url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.27 5.82 21l1.18-6.86L2 9.27l6.91-1.01L12 2z\"/></svg>')",
                  maskSize: "cover",
                  backgroundColor: "#7C3AED",
                }}
              />
            </div>
          );
        })}
      </div>
  );
};

export default StarRating;
